import React, { useState } from 'react';
import {ScheduleType as ScheduleTypeConstants} from '../../constants';
import EditButton from '../editButton';
import formatter from "../../../../../../utils/formatter";
import { AlertMessagePrimary } from '../popup';
import { capitalizeText } from '../../util';
import { StepperHoverTitle } from '../stepper/styles';
import { initiateTracking, recordError } from '../../../../../../utils/commonUtil';

const Info = (props) => {
    const {scheduleType, history, stepData, id, location, isDirty} = props;
    const [warn, setWarn] = useState(false);
    const navigate = () => {
        history.push({
            pathname: `/investments/recommend-an-exchange/${id}/from`,
            state: {
                prev: location
            }
        })
    }
    const handleEdit = (e) => {
        try {
            const scheduleTypeLabel = scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
            const currentLocation = location.pathname === '/investments/recommend-an-exchange/NEW/to' ? 'Step 2 Recommend exchange to' : 'Step 3 Review exchange and submit';
            initiateTracking('edit', 'Recommend An Exchange', currentLocation, `Edit - ${scheduleTypeLabel} - Step 1 Recommend exchange from - Stepper`);
            if(isDirty) {
                setWarn(true);
            } else {
                navigate();
            }
        } catch (error) {
            recordError(error);
        }
    };
    const handleResponse = (isContinue) => {
        setWarn(false);
        if (isContinue) {
            navigate();
        }
    }
    return (
        <div className='flex items-center'>
            <div>
                <StepperHoverTitle>Recommend exchange from</StepperHoverTitle>
                {scheduleType === ScheduleTypeConstants.onetime && <>
                    <div>Schedule: One Time Exchange</div>
                    <div>Type: {capitalizeText(stepData.exchangeType)} Exchange</div>
                </>}
                {scheduleType === ScheduleTypeConstants.recurring && <>
                    <div>Schedule: {stepData.numberOfExchanges} Recurring Exchanges</div>
                    <div>Start Date: {stepData.startDate} ({stepData.frequency})</div>
                </>}
                <div>Amount: {formatter({ value: stepData.total, fieldSuffix: "Dollars" })}</div>
                <div>From: {stepData.pools.length} Investment Pool(s)</div>
            </div>
            <EditButton onClick={handleEdit}></EditButton>
            <AlertMessagePrimary                
                title='Alert'
                visible={warn}
                onCancel={(e) => handleResponse(false)}
                onOk={(e) => handleResponse(true)}
            >
                Changing the step might result in loss of data entered so far.
                Are you sure you want to continue?
            </AlertMessagePrimary>
        </div>
    )
}
export default Info;